// extracted by mini-css-extract-plugin
export default {"content__items":"Cart_content__items__hiuxP"};